var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_882_2654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_882_2654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50814 18.7C4.05797 18.7 3.67747 18.5445 3.36664 18.2335C3.05581 17.9225 2.90039 17.5418 2.90039 17.0913V6.9008C2.90039 6.4503 3.05581 6.07088 3.36664 5.76255C3.67747 5.45422 4.05797 5.30005 4.50814 5.30005H19.4926C19.9428 5.30005 20.3233 5.45555 20.6341 5.76655C20.945 6.07755 21.1004 6.4583 21.1004 6.9088V17.0993C21.1004 17.5498 20.945 17.9292 20.6341 18.2375C20.3233 18.5459 19.9428 18.7 19.4926 18.7H4.50814ZM12.0004 12.7578L4.20039 8.1673V17.0923C4.20039 17.1821 4.22922 17.2559 4.28689 17.3135C4.34456 17.3712 4.41831 17.4001 4.50814 17.4001H19.4926C19.5825 17.4001 19.6562 17.3712 19.7139 17.3135C19.7716 17.2559 19.8004 17.1821 19.8004 17.0923V8.1673L12.0004 12.7578ZM12.0004 11.075L19.6466 6.60005H4.35414L12.0004 11.075ZM4.20039 8.1673V6.60005V17.0923C4.20039 17.1821 4.22922 17.2559 4.28689 17.3135C4.34456 17.3712 4.41831 17.4001 4.50814 17.4001H4.20039V8.1673Z",
    fill: "#9B9B9B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.d840a14d1582a1f929f7b803c971c65c.svg";
export { ForwardRef as ReactComponent };